// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileImageOutlinedSvg from "@fishx/icons-svg/es/asn/FileImageOutlined";
import FishxIcon from '../components/FishxIcon';

var FileImageOutlined = function FileImageOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileImageOutlinedSvg
  }));
};

FileImageOutlined.displayName = 'FileImageOutlined';
export default React.forwardRef(FileImageOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileImageOutlined.js
// module id = 2714
// module chunks = 0